import React, {Component} from 'react';
import { FormGroup } from 'arag-ui-lib';
import { LEGAL_ADVICE_TEXT } from '../helpers/variables';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { ENTER, INPUT_CHANGE, NO_FILTER } from '../helpers/constants';
import SolicitorFirmSearchSelect from './solicitorFirmSearchSelect';

class AgentsListFilters extends Component {
	constructor(props) {
		super(props);
	}

	onFirmFilterChange = (selectedOption) => {
		const value = selectedOption ? selectedOption.value : NO_FILTER;
		this.props.ChangeAgentsListSettings('filterBySolicitorFirm', value === NO_FILTER ? null : selectedOption);
		this.props.FilterByLawsysId(value);
	};

	onInputChange = (newValue, actionMeta) => {
		if (actionMeta.action !== INPUT_CHANGE) return;
		if (newValue === '') {
			this.props.SolicitorDisplaySetting('suggestions', this.props.User.allSolicitorUsers);
			this.props.UpdateSolicitorsDisplayedUsers(this.props.User.allSolicitorUsers);
		}
		this.props.SolicitorDisplaySetting('value', newValue);
	};

	onAgentSuggestionSelected = (selectedOption) => {
		if (!selectedOption) return;
		const suggestion = selectedOption.data;
		this.props.UpdateSolicitorsDisplayedUsers([suggestion]);
		const payload = {
			data: [suggestion],
			limit: 0,
			offset: 0,
			totalRecords: 1
		};
		this.props.receiveGetSolicitors(payload);
		this.props.SolicitorDisplaySetting('value', `${suggestion.forename} ${suggestion.surname}`);
	};

	render() {
		const { onQuickSearch } = this.props;
		const inputValue = this.props.User.solicitorUsersListSettings.value;
		const suggestions = this.props.User.solicitorUsersListSettings.suggestions || [];

		const suggestionOptions = suggestions.map(s => ({
			value: s.id,
			label: `${s.forename} ${s.surname}`,
			data: s
		}));

		const noFilterOption = { value: NO_FILTER, label: `${CONTENT_STRINGS.SELECT} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}` };
		const selectedFirm = this.props.User.filterBySolicitorFirm;
		const selectedFirmOption = selectedFirm && selectedFirm.value === this.props.User.filterBySolicitor ? selectedFirm : noFilterOption;

		return (
			<div className={"row agentList-formFilters-wrapper"}>
				<div className={"col-sm-12"}>
					<form className={"form-horizontal"} onSubmit={(e) => e.preventDefault()}>
						<SolicitorFirmSearchSelect
							labelSize={"col-sm-3"}
							inputSize={"col-sm-7"}
							label={`${CONTENT_STRINGS.FILTER_BY} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`}
							instanceId={'agentsListFirmFilter'}
							extraOptions={[noFilterOption]}
							onChange={this.onFirmFilterChange}
							value={selectedFirmOption}
							formGroupTestId={"solicitor-users-filter-by-solicitor"}
						/>
						<div onKeyPress={(evt) => evt.key === ENTER ? (evt.preventDefault(), onQuickSearch()) : null}>
							<FormGroup
								labelSize={"col-sm-3"}
								inputSize={"col-sm-7"}
								label={CONTENT_STRINGS.SEARCH}
								variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
								inputProps={{
									instanceId: 'agentsListSearch',
									options: suggestionOptions,
									onChange: this.onAgentSuggestionSelected,
									onInputChange: this.onInputChange,
									inputValue: inputValue,
									value: null,
									placeholder: CONTENT_STRINGS.SEARCH,
									noOptionsText: CONTENT_STRINGS.NO_AGENTS_FOUND,
									onSearchIconClick: onQuickSearch,
									filterOption: () => true
								}}
								formGroupTestId={"solicitor-users-search"}
							/>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default AgentsListFilters;
